export default "__VITE_ASSET__BPbYLYGb__"